// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionC1_comp__nnXvM"};